import React, { useState, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import styles from './ForgotPassword.module.css';
import InputField from '../../components/inputfield/InputField';
import CustomButton from '../../components/buttons/CustomButton';
import LogoImage from '../../assets/images/logo-full.png';
import { RequestPasswordResetAPI } from '../../api/API';
import { clearAccessToken } from '../../api/authTokens';
import Loading from '../../components/loading/Loading';

function ForgotPassword() {
  const navigate = useNavigate();
  const [emailSent, setEmailSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const inputFieldEmailRef = useRef(null);

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!email) {
      return 'O email é obrigatório';
    }
    if (!emailRegex.test(email)) {
      return 'Digite um email válido';
    }
    return null;
  };

  const handleSendEmail = () => {
    const email = inputFieldEmailRef.current.GetValue();
    const emailError = validateEmail(email);
    
    if (emailError) {
      inputFieldEmailRef.current.SetError(emailError);
      return;
    }

    if (inputFieldEmailRef.current.Validate()) {
      setLoading(true);
      setErrorMessage(null);
      
      // Clear all session data and cache before requesting password reset
      clearAccessToken();
      localStorage.removeItem('userData');
      // Mantém o email lembrado se o usuário optou por isso
      // localStorage.removeItem('rememberedEmail');
      // localStorage.removeItem('rememberMe');
      sessionStorage.clear();
      
      // Clear any URL parameters that might be in the current URL
      if (window.history && window.history.replaceState) {
        const cleanUrl = window.location.pathname;
        window.history.replaceState({}, document.title, cleanUrl);
      }
      
      RequestPasswordResetAPI(email, (response) => {
        setLoading(false);
        
        if (response.error) {
          setErrorMessage(response.error);
          return;
        }
        
        setEmailSent(true);
      });
    }
  };

  // Check for token in URL when component mounts and redirect to reset password page
  React.useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const urlToken = urlParams.get('token');
    
    if (urlToken) {
      // Use replace: true to replace the current URL in history
      // This prevents navigation issues after password reset
      navigate(`/reset-password?token=${encodeURIComponent(urlToken)}`, { replace: true });
    }
  }, [navigate]);
  
  return (
    <div className={styles.container}>
      {loading ? <Loading /> : (
      <div className={styles.containerForm}>
        <div className={styles.logoContainer}>
          <img className={styles.logo} src={LogoImage} alt="Logo" />
          <h1 className={styles.title}>Recuperar Senha</h1>
          {!emailSent && (
            <p className={styles.subtitle}>
              Digite seu email para receber as instruções de recuperação de senha
            </p>
          )}
        </div>
        
        {errorMessage && (
          <div className={styles.errorMessage}>
            {errorMessage}
          </div>
        )}

        {emailSent ? (
          <div className={styles.successMessage}>
            <strong>Email enviado com sucesso!</strong>
            <br />
            <span>Verifique sua caixa de entrada para instruções de redefinição de senha.</span>
          </div>
        ) : (
          <>
            <InputField
              Width={"100%"}
              Label={"Email"}
              type="email"
              placeholder="Digite seu email"
              ref={inputFieldEmailRef}
            />
            <CustomButton
              variant="contained"
              style="primary"
              label={"Enviar Instruções"}
              onClick={handleSendEmail}
            />
          </>
        )}

        <div className={styles.backLink}>
          <Link to="/login">Voltar para o login</Link>
        </div>
      </div>
      )}
    </div>
  );
}

export default ForgotPassword;